<template>
<div>
    <v-chip :outlined="outlined" label x-small :color="textColor" v-if="type==='Normal'" :class="outlined ? 'black--text' : 'white--text'" >
    <strong>{{ selectModel(modelValue, dataSelectorKey)?successText:errorText }}</strong>
    </v-chip>
    <div v-else-if="type==='BoldText'" :style="`color: ${textColor}`" >
      <strong>
        {{ selectModel(modelValue, dataSelectorKey)?successText:errorText }}
      </strong>
    </div>

    <div v-else :class="`dot heartbeat`" :style="`background:${textColor};opacity:0.7`">
      
    </div>
</div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import ModelVue from "../../ModelVue";
import { BooleanCellType } from "./FCellBooleanMDP";

@Component({
  components: {},
})
export default class FCellBoolean extends ModelVue {


  @Prop()
  dataSelectorKey: string;

  @Prop({
    default: BooleanCellType.Normal
  })
  type: BooleanCellType;
  
  @Prop()
  errorColor: string;
  @Prop()
  successColor: string;
  
  @Prop()
  hideFalseValue: boolean;

  @Prop({default:false})
  outlined: boolean;
  @Prop({
    default: "Yes"
  })
  successText: string;

  @Prop({
    default: "No"
  })
  errorText: string;
  
  
  get textColor(): string {
    return this.selectModel(this.modelValue, this.dataSelectorKey)?this.successColor:this.hideFalseValue?"transparent":this.errorColor
  }
}
</script>

<style scoped>
.dot {
  position: relative;
  width: fit-content;
  border-radius: 40px;
  width: 8px;
  height: 8px;
}
.green {
  background: green;
}
.orange {
  background-color: red !important;
}
</style>
